export const Secundary = (props) => {
  return (
    <div>
      <button
        type={props.onClick ? "button" : "submit"}
        onClick={props.onClick}
        className="w-full text-md flex justify-center py-2 px-4 border border-transparent rounded-full shadow-xs font-semibold text-tdark bg-purpleLight transition duration-300 hover:bg-purple  hover:text-white focus:outline-hidden"
        style={{ cursor: "pointer" }}
      >
        {props.text}
      </button>
    </div>
  );
};
